export enum EcrCodeStatusEnum {
    None = -1,
    Valid = 0,
    Expired = 1,
    NotExists = 2,
}

export function ecrCodeStatusEnumLabel(value: EcrCodeStatusEnum): string {
    switch (value) {
        case EcrCodeStatusEnum.None:
            return "common.all"
        case EcrCodeStatusEnum.Valid:
            return "enum.ecrCodeStatus.valid";
        case EcrCodeStatusEnum.Expired:
            return "enum.ecrCodeStatus.expired";
        case EcrCodeStatusEnum.NotExists:
            return "enum.ecrCodeStatus.notExists";
        default:
            return "common.unknown";
    }
}